import React from "react";
import { Routes, Route } from "react-router-dom";
import {
  PAGE_PORTAL_ORDERS_PURCHASE_LIST,
  PAGE_PORTAL_ORDERS_PURCHASE_DETAIL,
  PAGE_PORTAL_ORDERS_SALES_LIST,
  PAGE_PORTAL_ORDERS_SALES_DETAIL,
  PAGE_PORTAL_ORDERS_INVOICES_LIST,
  PAGE_PORTAL_ORDERS_INVOICE_DETAIL,
  PAGE_PORTAL_ORDERS_PAYMENTS_LIST,
  PAGE_PORTAL_ORDERS_PAYMENT_DETAIL,
  PAGE_PORTAL_ORDERS_RECEIPTS_LIST,
  PAGE_PORTAL_ORDERS_RECEIPT_DETAIL
} from "@kivunova/kivufrontendcommon";

import PurchaseOrderList from "./Orders/PurchaseOrder/PurchaseOrderList";
import PurchaseOrderDetailPage from "./Orders/PurchaseOrder/PurchaseOrderDetailPage";
import SalesOrderList from "./Orders/SalesOrder/SalesOrderList";
import SalesOrderDetailPage from "./Orders/SalesOrder/SalesOrderDetailPage";

import InvoiceList from "./Invoice/InvoiceList";
import InvoiceDetailPage from "./Invoice/InvoiceDetailPage";
import PaymentList from "./Payment/PaymentList";
import PaymentDetailPage from "./Payment/PaymentDetailPage";
import ReceiptList from "./Receipt/ReceiptList";
import ReceiptDetailPage from "./Receipt/ReceiptDetailPage";
import CompanyCurrencyBootstrap from "./common/CompanyCurrencyBootstrap/CompanyCurrencyBootstrap";

/**
 * Nested routes for the Order & Finance module (merged from OrderManagementMFE).
 *
 * Mounted by the container at:
 * - /portal/orders/*
 * - /portal/finance/*
 *
 * Therefore ALL paths here are RELATIVE (remove "orders/" prefix from constants).
 */
const OrderRoutes = () => {
  // Extract relative paths by removing the "orders/" prefix
  const ordersPrefix = "orders/";
  const purchasePath = PAGE_PORTAL_ORDERS_PURCHASE_LIST.replace(
    ordersPrefix,
    ""
  );
  const purchaseDetailPath = PAGE_PORTAL_ORDERS_PURCHASE_DETAIL.replace(
    ordersPrefix,
    ""
  );
  const salesPath = PAGE_PORTAL_ORDERS_SALES_LIST.replace(ordersPrefix, "");
  const salesDetailPath = PAGE_PORTAL_ORDERS_SALES_DETAIL.replace(
    ordersPrefix,
    ""
  );
  const invoicesPath = PAGE_PORTAL_ORDERS_INVOICES_LIST.replace(
    ordersPrefix,
    ""
  );
  const invoiceDetailPath = PAGE_PORTAL_ORDERS_INVOICE_DETAIL.replace(
    ordersPrefix,
    ""
  );
  const paymentsPath = PAGE_PORTAL_ORDERS_PAYMENTS_LIST.replace(
    ordersPrefix,
    ""
  );
  const paymentDetailPath = PAGE_PORTAL_ORDERS_PAYMENT_DETAIL.replace(
    ordersPrefix,
    ""
  );
  const receiptsPath = PAGE_PORTAL_ORDERS_RECEIPTS_LIST.replace(
    ordersPrefix,
    ""
  );
  const receiptDetailPath = PAGE_PORTAL_ORDERS_RECEIPT_DETAIL.replace(
    ordersPrefix,
    ""
  );

  return (
    <CompanyCurrencyBootstrap>
      <Routes>
        {/* Default route - show sales orders when at /portal/orders */}
        <Route path="/" element={<SalesOrderList />} />

        {/* Purchase Orders */}
        <Route path={purchasePath} element={<PurchaseOrderList />} />
        <Route
          path={purchaseDetailPath}
          element={<PurchaseOrderDetailPage />}
        />

        {/* Sales Orders */}
        <Route path={salesPath} element={<SalesOrderList />} />
        <Route path={salesDetailPath} element={<SalesOrderDetailPage />} />

        {/* Invoices */}
        <Route path={invoicesPath} element={<InvoiceList />} />
        <Route path={invoiceDetailPath} element={<InvoiceDetailPage />} />

        {/* Payments */}
        <Route path={paymentsPath} element={<PaymentList />} />
        <Route path={paymentDetailPath} element={<PaymentDetailPage />} />

        {/* Receipts */}
        <Route path={receiptsPath} element={<ReceiptList />} />
        <Route path={receiptDetailPath} element={<ReceiptDetailPage />} />
      </Routes>
    </CompanyCurrencyBootstrap>
  );
};

export default OrderRoutes;
